import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Welcome from "./Welcome";
import Comprehend from "./Comprehend";
import ModeGraphic from "./components/indicators/ModeGraphic";
import useDashboard from "./hooks/useDashboard";
import { useSidebarDarkMode } from "../../layouts/private/components/sidebar/sidebarColorMode";

const DashboardHeader = ({ sidebarDark }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: { xs: "start", sm: "center" },
        flexDirection: { xs: "column", sm: "row" },
        px: { xs: 2, sm: 3 },
        pt: { xs: 2, sm: 3 },
      }}
    >
      <Typography
        sx={{
          color: sidebarDark ? "#281543" : "#2F194F",
          fontSize: { xl: "21px", xs: "19px" },
          fontWeight: 500,
          lineHeight: 1.15,
        }}
      >
        Desempenho das campanhas
      </Typography>
    </Box>
  );
};

function DashboardPage() {
  const { sentiments, totalMessages, loading } = useDashboard();
  const sidebarDark = useSidebarDarkMode();

  return (
    <Box
      display="flex"
      flexDirection="column"
      minHeight="100vh"
      width="100%"
    >
      <Box
        sx={{
          width: "100%",
        }}
      >
        {/* Header Superior */}
        <Box
          display="flex"
          gap={{ xs: 3.5, sm: 4, lg: 3 }}
          padding={{ xs: 2, sm: 3 }}
          sx={{ flexDirection: { xs: "column", lg: "row" } }}
        >
          <Welcome />
          <Comprehend
            sentiments={sentiments}
            totalMessages={totalMessages}
            loading={loading}
          />
        </Box>

        {/* Conteúdo Principal */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#FFFFFF",
            borderRadius: "16px",
            border: sidebarDark ? "1px solid #E2D9F0" : "1px solid #ECEAF4",
            margin: { xs: "0 16px 16px", sm: "0 24px 24px" },
            boxShadow: "0 22px 46px rgba(15, 23, 42, 0.085)",
            overflow: "hidden",
          }}
        >
          <DashboardHeader sidebarDark={sidebarDark} />
          <ModeGraphic />
        </Box>
      </Box>
    </Box>
  );
}

export default DashboardPage;
